<template>
    <div class="form">
        <fieldset class="fieldset mrg" data-mrgt="20" :disabled="isLoading">
            <div class="form-items cf">
                <div class="item">
                    <div class="control">
                        <label class="label" for="Email">{{ localizer.get("App.Account.Email") }}</label>
                        <input type="email" id="Email" v-model.lazy="formData.email" autocomplete="email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox short']" />
                        <span class="valid-sign">*</span>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="fieldset">
            <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                <ul>
                    <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                </ul>
            </div>
            <div class="form-items" data-type="buttons">
                <div class="item calltoaction">
                    <button id="ButtonSubmit" class="button" @click="submitForm()" :disabled="isLoading"><span class="lable">{{ localizer.get("Account.Common.Button_Next") }}</span></button>
                </div>
            </div>
            <div class="item">
                <div class="captcha-terms" v-html="localizer.get('App.Recaptcha.CaptchaTerms')"></div>
            </div>
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    recaptchaSiteKey?: string
}>();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });
        try {
            let response = await Axios.post(routes.Account_PasswordRemind, formData.value, { headers: { "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "account_login");

            window.location.href = response.data.redirectUrl ? response.data.redirectUrl : "/";
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoading.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>